module.exports = __webpack_public_path__ + "img/img0308.046e2611.png";